recordOptimisticTransaction